/* eslint-disable max-len */
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppBar, Box, Container, Toolbar, Typography } from "@mui/material";
import InfoByName from "../pages/Interoperability/AADE/InfoByName";
import InfoByAFM from "../pages/Interoperability/AADE/InfoByAFM";
import InfoByADT from "../pages/Interoperability/AADE/InfoByADT";
import Sidebar from "../components/Sidebar/Sidebar";
import { routes_to_hide_navbar } from "../lib/static_values";
import ConfirmBank from "../pages/Interoperability/Bank/ConfirmBank";
import UserService from "../services/UserService";
import RetrievePAAYPA from "../pages/Interoperability/HDIKA/RetrievePAAYPA";
import RetrieveAMKA from "../pages/Interoperability/HDIKA/RetrieveAMKA";
import RetrievePersonalData from "../pages/Interoperability/HDIKA/RetrievePersonalData";
import RetrieveForesInfo from "../pages/Interoperability/e-Paravolo/RetrieveForesInfo";
import ParavolaInfo from "../pages/Interoperability/e-Paravolo/ParavolaInfo";
import GeneralInfo from "../pages/Interoperability/e-Paravolo/GeneralInfo";
import ApplicantInfo from "../pages/Interoperability/e-Paravolo/ApplicantInfo";
import ParavoloTypeInfo from "../pages/Interoperability/e-Paravolo/ParavoloTypeInfo";
import ParavoloStatusInfo from "../pages/Interoperability/e-Paravolo/ParavoloStatusInfo";
import CreateParavolo from "../pages/Interoperability/e-Paravolo/CreateParavolo";
import ValididateGemi from "../pages/Interoperability/GEMI/ValididateGemi";
import GemiBoard from "../pages/Interoperability/GEMI/GemiBoard";
import GemiInfo from "../pages/Interoperability/GEMI/GemiInfo";
import AdminUnitsDashboard from "../pages/Admin/AdminUnitsDashboard";
import UsersDashboard from "../pages/UsersDashboard";
import ApplicationsDashboard from "../pages/ApplicationsDashboard";
import CreateUser from "../pages/CreateUser";
import AddFilmOffice from "../pages/Admin/AddFilmOffice";
import FrontOfficeForm from "../pages/FrontOfficeForm";
import ViewApplication from "../pages/ViewApplication";
import EditFilmOffice from "../pages/EditFilmOffice";
import EditFrontOffice from "../pages/EditFrontOffice";
import FilmOfficeDetails from "../pages/FilmOfficeDetails";
import FrontOfficeDetails from "../pages/FrontOfficeDetails";
import UserDetails from "../pages/UserDetails";
import EditUser from "../pages/EditUser";
import {
  InteroperabilityPermissions,
  IntExt,
  OptionsPermissions,
  Permissions,
  PermissionsManageExternalUsers,
  PermissionsManageInternalUsers,
  PermissionsRolesManagement,
} from "../lib/permissions";
import LocationsDashboard from "../pages/Admin/LocationsDashboard";
import ProfessionalsDashboard from "../pages/Admin/ProfessionalsDashboard";
import UserProfile from "../pages/Admin/UserProfile";
import RoleHandling from "../pages/Admin/RoleHandling";
import ViewInternalRole from "../pages/Admin/permissions/internal/ViewInternalRole";
import ViewExternalRole from "../pages/Admin/permissions/external/ViewExternalRole";
import EditInternalRole from "../pages/Admin/permissions/internal/EditInternalRole";
import EditExternalRole from "../pages/Admin/permissions/external/EditExternalRole";
import NewFormPreview from "../pages/Admin/applications/NewFormPreview";
import SmartIndexForms from "../pages/Admin/applications/_smart/SmartIndex";
import VisitorDetails from "../pages/VisitorDetails";
import ViewProfApplication from "../pages/professionals/ViewProfApplication";
import ApplicationFormEdit from "../pages/ApplicationFormEdit";
import PreviewContext from "../components/context/PreviewContext";
import ProfDetails from "../pages/professionals/ProfDetails";
import CreateProfessional from "../pages/professionals/CreateProfessional";
import PreviewPage from "../pages/PreviewPage";
import EditProfessional from "../pages/professionals/EditProfessional";
import CreateInternalRole from "../pages/Admin/permissions/internal/CreateInternalRole";
import CreateExternalRole from "../pages/Admin/permissions/external/CreateExternalRole";
import AfeBoard from "../pages/Interoperability/AFE/AfeValidation";
import ViewFromScratchRequest from "../pages/Admin/applications/id";
import SmartSpecificFormDetails from "../pages/Visitor/applications/_smart/SmartSpecificFormDetails";
import SmartNewFormRequest from "../pages/Admin/applications/_smart/SmartNewFormRequest";
import EditVisitor from "../pages/EditVisitor";
import MyInternalRequests from "../pages/Admin/MyInternalRequests";
import ApplicationForm from "../pages/ApplicationForm";
import AdminLogin from "../pages/Admin/AdminLogin";
import logo_icon from "../assets/logo_icon.png";
import LocationDetails from "../pages/locationDetails";
import PreviewProfessional from "../pages/professionals/PreviewProfessional";
import Kad from "../pages/Interoperability/AADE/Kad";
import Dashboard from "../pages/Interoperability/Dashboard";
import RegistrationOrganisation from "../pages/ΟΑ/Registrations/RegistrationOrganisation";
import RegistrationCollection from "../pages/ΟΑ/Registrations/RegistrationCollection";
import RegistrationDocument from "../pages/ΟΑ/Registrations/RegistrationDocument";
import RegistrationProject from "../pages/ΟΑ/Registrations/RegistrationProject";
import ApisDashboard from "../pages/Admin/ApisDashboard";
import { UnauthorizedRedirect } from "../components/UnauthorizedRedirect";
import { PermissionsManageLocProf } from "../lib/permissions";
import EmailsDashboard from "../pages/Admin/EmailsDashboard";
import ViewLocationForm from "../pages/ViewLocationForm";
import ForeasDashboard from "../pages/ΟΑ/Foreas/ForeasDashboard";
import CollectionDashboard from "../pages/ΟΑ/Sulloges/CollectionDashboard";
import TekmirioDashboard from "../pages/ΟΑ/Tekmirio/TekmirioDashboard";
import ErgoDashboard from "../pages/ΟΑ/Ergo/ErgoDashboard";
import EditForeas from "../pages/ΟΑ/Foreas/EditForeas";
import EditErgo from "../pages/ΟΑ/Ergo/EditErgo";
import EditSulloges from "../pages/ΟΑ/Sulloges/EditSulloges";
import EditTekmirio from "../pages/ΟΑ/Tekmirio/EditTekmirio";
import AuthKeycloakLandPage from "../pages/AuthKeycloakLandPage";
import Zoom from "../pages/Admin/Zoom";
import EditNewForm from "../pages/Admin/applications/EditNewForm";
import ApplicationForms from "../pages/Admin/ApplicationForms";
import SearchApplications from "../pages/Admin/SearchApplications";

function AppAdmin() {
  const { pathname } = useLocation();

  const hasAllInteroperabilityRoles = UserService.hasRole(
    Object.values(InteroperabilityPermissions)
  );

  React.useEffect(() => {
    if (pathname !== "/admin/organisation/registration-organisation") {
      localStorage.removeItem("foreasId");
    }
    if (pathname !== "/admin/collection/registration-collection") {
      localStorage.removeItem("collectionId");
    }
    if (pathname !== "/admin/document/registration-document") {
      localStorage.removeItem("documentId");
    }
    if (pathname !== "/admin/project/registration-project") {
      localStorage.removeItem("ergoId");
    }
  }, [pathname]);

  return (
    <>
      {routes_to_hide_navbar.includes(pathname.split("/").filter(Boolean)[0]) ||
      pathname.split("/")[0] == ""
        ? (
          <Container id='main-container' maxWidth='xl'
            sx={{ height: "100%" }}>
            <Box display='flex'>
              <Box sx={{ height: "100%" }}>
                {UserService.hasRole([IntExt.Internal])
                  ? (
                    <Sidebar />
                  )
                  : (
                    <AppBar
                      position='fixed'
                      sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                    >
                      <Toolbar>
                        <img
                          src={logo_icon}
                          alt='EKOME-logo'
                          style={{ maxWidth: "65px", maxHeight: "65px" }}
                        />
                        <Typography ml={2} variant='h3'
                          noWrap>
                          Διαχειριστικό
                        </Typography>
                      </Toolbar>
                    </AppBar>
                  )}
              </Box>
              <Box width='100%' sx={{ flexGrow: 1 }}>
                <Toolbar />
                <Routes>
                  <Route path='/' element={<Navigate to='/admin-login' />} />
                  <Route
                    path='/admin-login'
                    element={
                      <AdminLogin
                        redirectUriLogin={`${process.env.REACT_APP_APP_URL}/admin/profile`}
                      />
                    }
                  />
                  {UserService.hasRole([IntExt.Internal])
                    ? (
                      <>
                        <Route
                          path='/auth/keycloak/landpage'
                          element={<AuthKeycloakLandPage />}
                        />
                        <Route path='/admin'>
                          <Route path='profile' element={<UserProfile />} />
                          <Route path='profile/edit' element={<EditUser />} />
                          <Route path='applications'>
                            <Route index element={<SmartIndexForms />} />
                            <Route
                              path='dashboard'
                              element={<ApplicationsDashboard />}
                            />
                            <Route
                              path='my-requests'
                              element={<MyInternalRequests />}
                            />
                            <Route
                              path='new-form'
                              element={<SmartNewFormRequest />}
                            />
                            <Route
                              path='new-form/edit/:id'
                              element={<EditNewForm />}
                            />
                            <Route
                              path='view-interest/:id'
                              element={<ViewLocationForm />}
                            />
                            <Route path='preview' element={<NewFormPreview />} />
                            <Route
                              path='view/:id'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalLocationApplicationCreateMy_org,
                                ])
                                  ? (
                                    <ViewApplication />
                                  )
                                  : (
                                    <Navigate to='/' />
                                  )
                              }
                            />
                            <Route
                              path='details/:id'
                              element={<SmartSpecificFormDetails />}
                            />
                            <Route
                              path=':id'
                              element={<ViewFromScratchRequest />}
                            />
                          </Route>
                          <Route path='users'>
                            <Route path='dashboard' element={<UsersDashboard />} />
                            users/edit
                            <Route
                              path='new'
                              element={
                                UserService.hasRole([
                                  PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateAll,
                                  PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateMyOrg,
                                ])
                                  ? (
                                    <CreateUser />
                                  )
                                  : (
                                    <UnauthorizedRedirect to='/admin/profile' />
                                  )
                              }
                            />
                            <Route path=':id' element={<UserDetails />} />
                            <Route
                              path='edit/:id'
                              element={
                                UserService.hasRole([
                                  PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateAll,
                                  PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateMyOrg,
                                ])
                                  ? (
                                    <EditUser />
                                  )
                                  : (
                                    <UnauthorizedRedirect to='/' />
                                  )
                              }
                            />
                            <Route path='profile' element={<UserProfile />} />
                          </Route>
                          {UserService.hasRole([
                            PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                            PermissionsRolesManagement.PermissionsInternalRoleManagementRead,
                          ]) && (
                            <Route path='roles'>
                              <Route
                                path='dashboard'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementRead,
                                  ])
                                    ? (
                                      <RoleHandling />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/' />
                                    )
                                }
                              />
                              <Route
                                path='view-internal/:id'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementRead,
                                  ])
                                    ? (
                                      <ViewInternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                              <Route
                                path='view-external/:id'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementRead,
                                  ])
                                    ? (
                                      <ViewExternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                              <Route
                                path='edit-internal/:id'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                                  ])
                                    ? (
                                      <EditInternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                              <Route
                                path='edit-external/:id'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                                  ])
                                    ? (
                                      <EditExternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                              <Route
                                path='new-internal'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                                  ])
                                    ? (
                                      <CreateInternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                              <Route
                                path='new-external'
                                element={
                                  UserService.hasRole([
                                    PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
                                  ])
                                    ? (
                                      <CreateExternalRole />
                                    )
                                    : (
                                      <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                    )
                                }
                              />
                            </Route>
                          )}
                          <Route path='visitor'>
                            <Route
                              path=':id'
                              element={
                                UserService.hasRole([
                                  PermissionsManageExternalUsers.PermissionInternalManageExternalUserBasicInfoRead,
                                ])
                                  ? (
                                    <VisitorDetails />
                                  )
                                  : (
                                    <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                  )
                              }
                            />
                            <Route
                              path='edit/:id'
                              element={
                                UserService.hasRole([
                                  PermissionsManageExternalUsers.PermissionInternalManageExternalUserChangeRole,
                                ])
                                  ? (
                                    <EditVisitor />
                                  )
                                  : (
                                    <UnauthorizedRedirect to='/admin/roles/dashboard' />
                                  )
                              }
                            />
                          </Route>
                          <Route path='locations'>
                            <Route
                              path='dashboard'
                              element={
                                UserService.hasRole([
                                  PermissionsManageLocProf.PermissionInternalManageApplicationReadAll,
                                  PermissionsManageLocProf.PermissionInternalManageApplicationReadMyOrg,
                                ])
                                  ? (
                                    <LocationsDashboard />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της διαχείρισης τοποθεσιών'
                                    />
                                  )
                              }
                            />
                            <Route
                              path='details/:id'
                              element={<LocationDetails />}
                            />
                            <Route
                              path='new'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalLocationApplicationCreateMy_org,
                                  Permissions.PermissionInternalLocationApplicationCreateAll,
                                ])
                                  ? (
                                    <ApplicationForm />
                                  )
                                  : (
                                    <Navigate to='/' />
                                  )
                              }
                            />
                            <Route
                              path='edit/:id'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalLocationApplicationModificationRequestCreateMy_org,
                                  Permissions.PermissionInternalLocationApplicationModificationRequestCreateAll,
                                ])
                                  ? (
                                    <PreviewContext.PreviewProvider>
                                      <ApplicationFormEdit />
                                    </PreviewContext.PreviewProvider>
                                  )
                                  : (
                                    <Navigate to='/' />
                                  )
                              }
                            />
                            <Route
                              path='preview'
                              element={
                                <PreviewContext.PreviewProvider>
                                  <PreviewPage />
                                </PreviewContext.PreviewProvider>
                              }
                            />
                          </Route>
                          <Route path='professionals'>
                            <Route
                              path='view/:id'
                              element={<ViewProfApplication />}
                            />
                            <Route
                              path='new'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
                                  Permissions.PermissionInternalProfessionalsApplicationCreateAll,
                                ])
                                  ? (
                                    <CreateProfessional />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της προβολής επαγγελματιών'
                                    />
                                  )
                              }
                            />
                            <Route
                              path='details/:id'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
                                  Permissions.PermissionInternalProfessionalsApplicationCreateAll,
                                ])
                                  ? (
                                    <ProfDetails />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της προβολής επαγγελματιών'
                                    />
                                  )
                              }
                            />
                            <Route
                              path='edit/:id'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
                                  Permissions.PermissionInternalProfessionalsApplicationCreateAll,
                                ])
                                  ? (
                                    <EditProfessional />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της προβολής επαγγελματιών'
                                    />
                                  )
                              }
                            />
                            <Route
                              path='preview'
                              element={
                                UserService.hasRole([
                                  Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
                                  Permissions.PermissionInternalProfessionalsApplicationCreateAll,
                                ])
                                  ? (
                                    <PreviewProfessional />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της προβολής επαγγελματιών'
                                    />
                                  )
                              }
                            />
                            <Route
                              path='dashboard'
                              element={
                                UserService.hasRole([
                                  PermissionsManageLocProf.PermissionInternalManageProfessionalReadMyOrg,
                                  PermissionsManageLocProf.PermissionInternalManageProfessionalReadAll,
                                ])
                                  ? (
                                    <ProfessionalsDashboard />
                                  )
                                  : (
                                    <UnauthorizedRedirect
                                      to='/'
                                      snackMessage='Δεν έχετε δικαίωμα να δείτε το υλικό της διαχείρισης επαγγελματιών'
                                    />
                                  )
                              }
                            />
                          </Route>
                          <Route path='organisation'>
                            <Route
                              path='registration-organisation'
                              element={<RegistrationOrganisation />}
                            />
                            <Route path='dashboard' element={<ForeasDashboard />} />
                            <Route path=':id/edit' element={<EditForeas />} />
                          </Route>
                          <Route path='collection'>
                            <Route
                              path='dashboard'
                              element={<CollectionDashboard />}
                            />
                            <Route
                              path='registration-collection'
                              element={<RegistrationCollection />}
                            />
                            <Route path=':id/edit' element={<EditSulloges />} />
                          </Route>
                          <Route path='document'>
                            <Route
                              path='dashboard'
                              element={<TekmirioDashboard />}
                            />
                            <Route
                              path='registration-document'
                              element={<RegistrationDocument />}
                            />
                            <Route path=':id/edit' element={<EditTekmirio />} />
                          </Route>
                          <Route path='project'>
                            <Route path='dashboard' element={<ErgoDashboard />} />
                            <Route
                              path='registration-project'
                              element={<RegistrationProject />}
                            />
                            <Route path=':id/edit' element={<EditErgo />} />
                          </Route>
                          <Route path='units'>
                            <Route
                              path='dashboard'
                              element={<AdminUnitsDashboard />}
                            />
                            <Route path='film_office'>
                              <Route path='new' element={<AddFilmOffice />} />
                              <Route path='edit/:id' element={<EditFilmOffice />} />
                              <Route path=':id' element={<FilmOfficeDetails />} />
                            </Route>
                            <Route path='ekome'>
                              <Route path='new' element={<FrontOfficeForm />} />
                              <Route
                                path='edit/:id'
                                element={<EditFrontOffice />}
                              />
                              <Route path=':id' element={<FrontOfficeDetails />} />
                            </Route>
                          </Route>

                          {hasAllInteroperabilityRoles
                            ? (
                              <Route path='interoperability'>
                                <Route path='zoom' element={<Zoom />} />
                                <Route path='aade'>
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionInternalAadeName,
                                  ])
                                    ? (
                                      <Route path='name' element={<InfoByName />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionInternalAadeAfm,
                                  ])
                                    ? (
                                      <Route path='afm' element={<InfoByAFM />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionInternalAadeAdt,
                                  ])
                                    ? (
                                      <Route path='adt' element={<InfoByADT />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  <Route path='kad' element={<Kad />} />
                                </Route>
                                <Route path='hdika'>
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalIdikaAmka,
                                  ])
                                    ? (
                                      <Route path='amka' element={<RetrieveAMKA />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalIdikaPaaypa,
                                  ])
                                    ? (
                                      <Route
                                        path='paaypa'
                                        element={<RetrievePAAYPA />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalIdikaInfo,
                                  ])
                                    ? (
                                      <Route
                                        path='personal-data'
                                        element={<RetrievePersonalData />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                </Route>
                                <Route path='eparav'>
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloForea,
                                  ])
                                    ? (
                                      <Route
                                        path='foreas-info'
                                        element={<RetrieveForesInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloPerson,
                                  ])
                                    ? (
                                      <Route
                                        path='paravola'
                                        element={<ParavolaInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloInfo,
                                  ])
                                    ? (
                                      <Route
                                        path='general-info'
                                        element={<GeneralInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloInfoApplicant,
                                  ])
                                    ? (
                                      <Route
                                        path='applicant-info'
                                        element={<ApplicantInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloParavoloType,
                                  ])
                                    ? (
                                      <Route
                                        path='paravolo-type'
                                        element={<ParavoloTypeInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloParavoloState,
                                  ])
                                    ? (
                                      <Route
                                        path='paravolo-status'
                                        element={<ParavoloStatusInfo />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalEParavoloCreate,
                                  ])
                                    ? (
                                      <Route path='new' element={<CreateParavolo />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                </Route>
                                <Route path='gemi'>
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalGemiBasicInfo,
                                  ])
                                    ? (
                                      <Route
                                        path='validation'
                                        element={<ValididateGemi />}
                                      />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalGemiAdminGroup,
                                  ])
                                    ? (
                                      <Route path='board' element={<GemiBoard />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                  {UserService.hasRole([
                                    InteroperabilityPermissions.PermissionsInternalGemiBasicInfo,
                                  ])
                                    ? (
                                      <Route path='info' element={<GemiInfo />} />
                                    )
                                    : (
                                      <Route
                                        path='*'
                                        element={
                                          <Navigate to='/units/dashboard' replace />
                                        }
                                      />
                                    )}
                                </Route>
                                {UserService.hasRole([
                                  InteroperabilityPermissions.PermissionsInternalBankVerification,
                                ])
                                  ? (
                                    <Route
                                      path='confirm-bank'
                                      element={<ConfirmBank />}
                                    />
                                  )
                                  : (
                                    <Route
                                      path='*'
                                      element={
                                        <Navigate to='/units/dashboard' replace />
                                      }
                                    />
                                  )}
                                {UserService.hasRole([
                                  InteroperabilityPermissions.PermissionsInternalAfeIssue,
                                  InteroperabilityPermissions.PermissionsInternalAfeValidation,
                                  InteroperabilityPermissions.PermissionsInternalAfeVersion,
                                ])
                                  ? (
                                    <Route path='afe' element={<AfeBoard />} />
                                  )
                                  : (
                                    <Route
                                      path='*'
                                      element={
                                        <Navigate to='/units/dashboard' replace />
                                      }
                                    />
                                  )}
                              </Route>
                            )
                            : (
                              <Route
                                path='*'
                                element={<Navigate to='/units/dashboard' replace />}
                              />
                            )}
                          <Route path='settings'>
                            <Route
                              path='interoperability'
                              element={<Dashboard />}
                            />
                            <Route path='apis' element={<ApisDashboard />} />
                            <Route
                              path='emails'
                              element={
                                UserService.hasRole([
                                  OptionsPermissions.PermissionsInternalOptionsEmailEditor,
                                ])
                                  ? (
                                    <EmailsDashboard />
                                  )
                                  : (
                                    <UnauthorizedRedirect to='/admin/profile' />
                                  )
                              }
                            />
                            <Route path='edit-applications' element={
                              UserService.hasRole([Permissions.PermisionInternalPDFUpdate])
                                ? <ApplicationForms />
                                : <UnauthorizedRedirect to='/admin/profile' />
                            } />
                            <Route path='applications' element={
                              UserService.hasRole([Permissions.PermisionInternalPDFUpdate])
                                ? <SearchApplications />
                                : <UnauthorizedRedirect to='/admin/profile' />
                            } />
                          </Route>
                        </Route>
                      </>
                    )
                    : (
                      <Route
                        path='*'
                        element={<Navigate to='/admin-login' replace />}
                      />
                    )}
                </Routes>
              </Box>
            </Box>
          </Container>
        )
        : null}

      {/* } */}
    </>
  );
}

export default AppAdmin;
